// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"_74863e5","leftLabel":"_e86a4b9","rightLabel":"_0801bab","indicator":"_8307315","large":"_01fd5d4","small":"_a0152cb"};